<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white;">
            <br />
            <div class="col-sm-10 col-xs-12">
                <b-row>
                    <b-col sm="4" class="col-sm-4 col-xs-12 text-right">
                        <label>ชื่อวัสดุ</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <input v-model="form.name"
                               type="text"
                               class="form-control"
                              />
                    </b-col>
                </b-row>
                <br />
                <b-row>
                    <b-col sm="4" class="col-sm-4 col-xs-12 text-right">
                        <label>แหล่งที่มา</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <select class="form-control mr-sm-2 w-100"

                                v-model="form.source_id">
                            <option value="" hidden>โปรดเลือกแหล่งที่มา</option>
                            <option value="1">ในประเทศ</option>
                            <option value="2">นอกประเทศ</option>
                        </select>
                    </b-col>
                </b-row>
                <br />
                <b-row>
                    <b-col sm="4" class="col-sm-4 col-xs-12 text-right">
                        <label>จำนวน</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <input  v-if="form.id"
                                disabled
                                v-model="form.quantity"
                                type="number"
                                class="form-control"
                        />
                        <input  v-else
                                v-model="form.quantity"
                                type="number"
                                class="form-control"
                        />
                    </b-col>
                </b-row>
                <br />
                <b-row>
                    <b-col sm="4" class="col-sm-4 col-xs-12 text-right">
                        <label>ชื่อเจ้าหนี้</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <multiselect
                            v-model="form.vendor"
                            :options="optionVendor"
                            :customLabel="vendorLabel"
                            placeholder="เลือกรหัสเจ้าหนี้"
                            :show-labels="false">
                        </multiselect>
                    </b-col>
                </b-row>
                <br />
                <div class="offset-1 col text-center">
                    <button type="button"
                            @click="saveFactorialMaterial"
                            class="btn btn-success">
                        <icon name="save"></icon>
                        บันทึก
                    </button>
                    &nbsp;&nbsp;
                    <button type="button"
                            @click="goToFactorialMaterialList"
                            class="btn btn-outline-secondary">
                        <icon name="times"></icon>
                        ยกเลิก
                    </button>
                    &nbsp;&nbsp;
                    <button v-if="form.id"
                            type="button"
                            @click="showDeleteFactorialMaterialModal"
                            class="btn btn-danger">
                        <icon name="trash-alt"></icon>
                        ลบ
                    </button>
                </div>
            </div>
            <br />
        </div>

        <!-- Modal -->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br />
                <button
                        type="button"
                        class="btn btn-success"
                        @click="deleteFactorialMaterial">
                    ตกลง
                </button>
                &nbsp;&nbsp;
                <button
                        type="button"
                        class="btn btn-outline-secondary"
                        @click="hideDeleteFactorialMaterialModal">
                    ยกเลิก
                </button>
            </div>
        </b-modal>

<!--        <pre class="alert alert-primary">{{ form }}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import moment from "moment";
    import {Multiselect} from "vue-multiselect";

    export default {
        name: "factorial-material-information",
        components: {
            Multiselect
        },
        created() {
            this.getCurrentDate();
            this.onSave = false;
        },
        data() {
            return {
                optionSource:[
                    { value: null, text: 'โปรดเลือกแหล่งที่มา' },
                    { value: 1, text: 'ในประเทศ' },
                    { value: 2, text: 'นอกประเทศ' },
                ],
                items: [
                    {
                        text: "รายการวัสดุอุปกรณ์โรงงาน",
                        to: { name: "factorial-material-list" }
                    },
                    {
                        text: "เพิ่มเติม",
                        active: true
                    }
                ],
                onSave: false
            };
        },
        computed: {
            ...mapState({
                user: state => {
                    return state.Auth.user;
                },
                form: state => {
                    return state.FactorialMaterial.form;
                },
                optionVendor: state => {
                    return state.Vendor.vendorAll
                },
            })
        },
        methods: {
            vendorLabel (option) {
                return `${option.vendor_id} - ${option.name}`
            },
            showDeleteFactorialMaterialModal() {
                this.$refs.delete_item.show();
            },
            hideDeleteFactorialMaterialModal() {
                this.$refs.delete_item.hide();
            },
            goToFactorialMaterialList() {
                this.$router.push({
                    name : "factorial-material-list"
                })
            },
            saveFactorialMaterial() {
                this.onSave = true;
                if(!this.form.name){
                    alert('กรุณาใส่ชื่อวัสดุ')
                }
                else if(!this.form.source_id){
                    alert('กรุณาเลือกแหล่งที่มา')
                }
                else{
                    if (this.form.vendor)this.form.vendor = this.form.vendor.id;
                    this.$store.dispatch("FactorialMaterial/saveFactorialMaterial", this.form).then(() => {
                        this.onsave= false;
                        this.goToFactorialMaterialList();
                    });
                }
            },
            deleteFactorialMaterial() {
                this.$store.dispatch("FactorialMaterial/delete", this.form.id).then(() => {
                    this.hideDeleteFactorialMaterialModal();
                    this.goToFactorialMaterialList();
                });
            },
            getCurrentDate() {
                const currentDate = moment().format("YYYY-MM-DD");
                this.form.date = currentDate;
                this.form.expire_date = currentDate;
            }
        }
    }
</script>

<style scoped>

</style>
